export enum TelematicsStatusFilter {
  FREE_UNDER_24H = 'free-under-24h',
  FREE_OVER_24H = 'free-over-24h',
  FAILURE = 'failure',
  WAITING = 'waiting',
  LOADING = 'loading',
  UNLOADING = 'unloading',
  RIDE = 'ride',
  OFF_ROUTE = 'off-route',
}
